
import { Link } from 'react-router-dom';

const Footer = () => {
    return(
        <footer className="footer mt-[auto] px-10 py-10 bg-white dark:bg-dark-content-bg dark:border-gray-800 border-[1px] ">
            <div className="flex justify-between text-gray-500 dark:text-white">
                <p>@ 2022 x-market inc.</p>
                <div className="flex flex-col md:flex-row justify-end items-end">
                    <a className = 'md:mr-3' href = "mailto: xmarketcontact1@gmail.com">xmarketcontact1@gmail.com</a>
                    <Link to = '/privacypolicy'>
                        Privacy
                    </Link>
                </div>
            </div>
        </footer>
    )
}

export default Footer;